<template>

    <div class="hitotonari_detail-container" v-bind:class="{_block: display}">
        <div class="inner">

            <h2 class="heading-section"><span>hitotonari.</span></h2>
            <div class="item-wrap">

                <!--IMG-->
                <div class="img-wrap">
                    <div class="main md_no-image" v-if="hitotonariData.image[1]!=='/img/no-image.svg'">
                        <img v-bind:src="hitotonariData.image[1]" alt="">
                    </div>
                    <div class="sub-row">
                        <div class="sub md_no-image" v-if="hitotonariData.image[2]!=='/img/no-image.svg'">
                            <img v-bind:src="hitotonariData.image[2]" alt="">
                        </div>
                        <div class="sub md_no-image" v-if="hitotonariData.image[3]!=='/img/no-image.svg'">
                            <img v-bind:src="hitotonariData.image[3]" alt="">
                        </div>
                    </div>
                </div>

                <!--Detail-->
                <div class="detail-wrap">

                    <!--Name-->
                    <div class="personal-info">
                        <h3 class="role"> {{ hitotonariData.post }} <span></span></h3>
                        <p class="name"> {{ hitotonariData.name }} </p>
                        <ul class="list_sns">
                            <li>
                                <a v-bind:href="hitotonariData.facebook" target="_blank" v-if="hitotonariData.facebook">
                                    <div class="md_icon-btn _outline">
                                        <div class="inner"><SvgIconSnsFacebook /></div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a v-bind:href="hitotonariData.twitter" target="_blank" v-if="hitotonariData.twitter">
                                    <div class="md_icon-btn _outline">
                                        <div class="inner _small"><SvgIconSnsTwitter /></div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a v-bind:href="hitotonariData.instagram" target="_blank" v-if="hitotonariData.instagram">
                                    <div class="md_icon-btn _outline">
                                        <div class="inner"><SvgIconSnsInstagram /></div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!--Text-->
                    <div class="text-wrap">
                        <h3> {{ hitotonariData.title }} </h3>
                        <p> {{ hitotonariData.description }} </p>
                    </div>

                    <!--History-->
                    <div class="history-wrap" v-if="hitotonariData.history">
                        <h3><span>History</span></h3>
                        <p>
                            <pre>
                                {{ hitotonariData.history }}
                            </pre>
                        </p>
                    </div>

                </div><!--/.Detail-->
            </div><!--/.item-wrap-->

            <!--Recommend-->
            <div class="recommend">
                <div class="item" v-for="(data, key, index) in questionAndAnswers" v-bind:key="index">
                    <!-- 選択 -->
                    <template v-if="data.question_check == 0"  v-for="select_question in select_questions"
                                v-bind:value="select_question.id "
                                v-bind:key="select_question.id">
                        <h3 v-if="data.question_select_id == select_question.id"><span>{{ select_question.name }}</span></h3>
                    </template>
                    <!-- 自由入力 -->
                    <template v-if="data.question_check == 1">
                        <h3><span>{{ data.question }}</span></h3>
                    </template>

                    <p><span>{{ data.answer }}</span></p>
                </div>
            </div><!--/.Recommend-->

        </div>
    </div><!--/.hitotonari_detail-container-->

</template>

<script>
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    export default {
        components: {
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
        },
        props: {
            hitotonariData: Object,
            display: Boolean,
        },
        data() {
            return {
                select_questions: [
                    { id: 1, name: 'ご自身のマインドフルネスの方法を教えて下さい。' },
                    { id: 2, name: '趣味を教えて下さい。' },
                    { id: 3, name: '尊敬している人を教えて下さい。' },
                ]
            };
        },
        computed: {
            questionAndAnswers() {
                if (this.hitotonariData.questionAndAnswers) {
                    var displayQandA = [];
                    for (var i in this.hitotonariData.questionAndAnswers) {
                        if (this.hitotonariData.questionAndAnswers[i].question_check || this.hitotonariData.questionAndAnswers[i].question_select_id || this.hitotonariData.questionAndAnswers[i].question || this.hitotonariData.questionAndAnswers[i].answer) {
                            displayQandA.push(this.hitotonariData.questionAndAnswers[i]);
                        }
                    }
                    return displayQandA;
                }
            },
        },
    }
</script>
